import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q7 = ({ history }) => {
  const { t } = useTranslation();
  const Q7Options = useMemo(
    () => [
      {
        id: 0,
        name: t('frequently'),
        value: 'frequently',
      },
      {
        id: 1,
        name: t('time_to_time'),
        value: 'time_to_time',
      },
      {
        id: 2,
        name: t('rarely'),
        value: 'rarely',
      },
      {
        id: 3,
        name: t('never'),
        value: 'never',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question7')}
      options={Q7Options}
      nextUrl="q8"
      screenName="q7"
    />
  );
};

export default Q7;
